import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import isValidEmailAddress from 'owa-recipient-common/lib/utils/isValidEmailAddress';

/**
 * Makes sure that all the recipients that are passed are valid
 */
export default function hasInvalidRecipients(recipients: AttendeeType[]): boolean {
    if (!recipients) {
        // No recipients mean there are no invalid recipients
        return false;
    }

    let hasInvalid: boolean = false;
    recipients.forEach(recipient => {
        if (!isValidEmailAddress(recipient.Mailbox.EmailAddress)) {
            hasInvalid = true;
        }
    });

    return hasInvalid;
}
